import React, {
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  createContext,
  useContext,
  useState,
} from 'react'

type LoadState = [boolean, Dispatch<SetStateAction<boolean>>]

const loadingContext = createContext<LoadState | undefined>(undefined)

const LoadingFieldsContext: React.FC<PropsWithChildren> = ({ children }: PropsWithChildren) => {
  const loadingFieldState = useState(false)

  return <loadingContext.Provider value={loadingFieldState}>{children}</loadingContext.Provider>
}

const useLoadingFields = (): LoadState => {
  const loadState: LoadState | undefined = useContext(loadingContext)

  if (!loadState) {
    throw 'Invalid state'
  }

  return loadState
}

export { LoadingFieldsContext, useLoadingFields }
